import { Component, EventEmitter, Input, Output } from '@angular/core';
import { JobTypeEnum } from 'server/shared/models/jobTypeEnum';

@Component({
  selector: 'app-job-type-select',
  templateUrl: './job-type-select.component.html',
  styleUrls: ['./job-type-select.component.scss'],
})
export class JobTypeSelectComponent {
  @Input() label?: string;
  @Input() disabled = false;
  @Input() required = false;
  @Input() lightFormField = false;
  @Input() selectedJobType?: JobTypeEnum;

  @Output() selectionChanged = new EventEmitter<JobTypeEnum>();

  jobTypeEnum = JobTypeEnum;

  constructor() {}

  onSelectionChange(selectedJobType: JobTypeEnum) {
    this.selectionChanged.emit(selectedJobType);
  }
}
